module.exports = __webpack_public_path__ + "static/img/top_bg.e2c35180.png";